import { motion } from "framer-motion";

const Title = (props) => {
  const { title, classname } = props;
  return (
    <motion.h2
      initial={{ opacity: 0 }}
      animate={{ x: [-150, 0], opacity: 1 }}
      transition={{ delay: 0 }}
      className={`mb-7 inline-block rounded-full px-6 py-1.5 text-lg font-medium dark:border dark:border-blue-400 dark:text-blue-100 sm:flex sm:justify-center sm:py-2 sm:text-xl ${classname}`}
    >
      {title}
    </motion.h2>
  );
};

export default Title;
